import { toast } from 'react-toastify';

// Custom toast functions with loading, success, and error states in a single toast
export const createLoadingToast = (message) => {
  return toast.loading(message, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: false,
    hideProgressBar: false
  });
};

export const updateToastWithSuccess = (toastId, message) => {
  toast.update(toastId, {
    isLoading: false,
    type: "success",
    render: message,
    autoClose: 0, // Disappear immediately
    hideProgressBar: true,
    style: {
      background: '#4caf50', // Green background
      color: '#ffffff',      // White text
      fontWeight: 'bold',
      borderRadius: '4px',
      boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
    }
  });
};

export const updateToastWithError = (toastId, message) => {
  toast.update(toastId, {
    isLoading: false,
    type: "error",
    render: message,
    autoClose: 4000,
    hideProgressBar: true,
    style: {
      background: '#f44336', // Red background
      color: '#ffffff',      // White text
      fontWeight: 'bold',
      borderRadius: '4px',
      boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
    }
  });
};

// Add CSS for spinner animation and modal z-index fix
export const setupCustomStyles = () => {
  const customStyles = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    
    /* Fix for modal z-index to appear above LabLayout elements */
    .ui.dimmer {
      z-index: 9999 !important;
    }
    
    .ui.modal {
      z-index: 10000 !important;
    }
  `;

  // Create a style element for the animation and modal z-index fix
  if (typeof document !== 'undefined') {
    const styleElement = document.createElement('style');
    styleElement.textContent = customStyles;
    document.head.appendChild(styleElement);
  }
};
